import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../../environments/environment';
import { SurveyAuthService } from '../../../../shared/survey-auth.service';
import { Page } from '../models/page';
import { Question } from '../models/question';

@Injectable()
export class QuestionService {
  constructor(private http: HttpClient, private auth: SurveyAuthService) {}

  insertQuestion(
    page: Page,
    question: Question,
    reference_question: Question
  ): Observable<any> {
    let post_url = `${environment.surveyApiHost}/api/v1/surveys/${
      page.getSurvey().id
    }/pages/${page.id}/questions/`;
    if (reference_question != null) {
      post_url = post_url + `?ref_question_id=${reference_question.id}`;
    }
    console.log('POST ' + post_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .post(post_url, question, { headers: headers })
      .map(this.processPostPutResponse)
      .catch(this.handleError);
  }

  updateQuestion(question: Question): Observable<any> {
    const put_url = `${environment.surveyApiHost}/api/v1/surveys/${
      question.getPage().getSurvey().id
    }/pages/${question.getPage().id}/questions/${question.id}/`;
    console.log('PUT ' + put_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);
    console.log('question: ', question.toJSON());
    return this.http
      .put(put_url, question.toJSON(), { headers: headers })
      .catch(this.handleError);
  }

  deleteQuestion(question: Question): Observable<any> {
    const delete_url = `${environment.surveyApiHost}/api/v1/surveys/${
      question.getPage().getSurvey().id
    }/pages/${question.getPage().id}/questions/${question.id}/`;
    console.log('DELETE ' + delete_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .delete(delete_url, { headers: headers })
      .catch(this.handleError);
  }

  moveQuestion(question: Question, new_order: number): Observable<any> {
    let get_url = `${environment.surveyApiHost}/api/v1/surveys/${
      question.getPage().getSurvey().id
    }/pages/${question.getPage().id}/questions/${question.id}/move`;
    if (new_order != null) {
      get_url = get_url + `?new_order=${new_order}`;
    }
    console.log('GET ' + get_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http.get(get_url, { headers: headers }).catch(this.handleError);
  }

  moveQuestion2(
    question: Question,
    ref_question: Question,
    ref_page?: Page
  ): Observable<any> {
    let get_url = `${environment.surveyApiHost}/api/v1/surveys/${
      question.getPage().getSurvey().id
    }/pages/${question.getPage().id}/questions/${question.id}/move`;
    let urls_params = null;
    if (ref_question != null) {
      urls_params = `ref_question=${ref_question}`;
    }
    if (ref_page != null) {
      if (urls_params != null) {
        urls_params = urls_params + `&ref_page=${ref_page}`;
      } else {
        urls_params = `ref_page=${ref_page}`;
      }
    }
    if (urls_params != null) {
      get_url = get_url + '?' + urls_params;
    }
    console.log('GET ' + get_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http.get(get_url, { headers: headers }).catch(this.handleError);
  }

  private processPostPutResponse(res: HttpResponse<any>): Question {
    console.log('processPostResponse: res: ', res);
    const body = res.body.json();
    console.log('processResponse: body: ', body);
    const question: Question = Object.create(Question.prototype);
    const obj = Object.assign(question, body, {});
    return obj || {};
  }

  private handleError(error: HttpResponse<any> | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof HttpResponse) {
      const body = error.body.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}
